import React, {useContext, useEffect, useState} from "react"
import {FormattedMessage, injectIntl} from "react-intl";
import Navbar from "./component/navbar";
import {chainWalk, getAssetRefreshInterval, getNodeId} from "../../../util/Util";
import BinTesterPage from "./view/bin-tester-page";
import AisleTester from "./view/aisle-tester-page";
import ControllerTesterPage from "./view/controller-tester-page";
import {loadSiteConfig} from "./config";
import {LEDControllerOverviewContext} from "../context/LEDControllerOverviewContext";
import LoaderView from "../../../loader/Loader";
import Alert from "@amzn/meridian/alert";

const BinTester = ({intl}) => {

    const {viewModel} = useContext(LEDControllerOverviewContext);
    const [siteId, setSiteId] = useState(getNodeId());
    const [siteConfig, setSiteConfig] = useState({});
    const [noLedControllers, setNoLedControllers] = useState(false);
    const [binShowFlag, setBinShowFlag] = useState(true);
    const [controllerShowFlag, setControllerShowFlag] = useState(false);
    const [clusterShowFlag, setClusterShowFlag] = useState(false);

    useEffect(() => {
        getData();
        if (chainWalk(() => Object.keys(viewModel.ledControllerDeviceInformation).length, 0) === 0) {
            return;
        }
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getAssetRefreshInterval());
        return () => clearInterval(interval);
    }, [siteId, viewModel.ledControllerDeviceInformation]);

    const updateSiteConfig = (siteConfig) => {
        setSiteConfig(siteConfig);
    }

    const updateSiteId = (siteId) => {
        setSiteId(siteId);
    }

    const getData = async () => {
        if (chainWalk(() => Object.keys(viewModel.ledControllerDeviceInformation).length, 0) === 0) {
            setNoLedControllers(true);
            return;
        }
        setNoLedControllers(false);
        const siteConfig = await loadSiteConfig();
        setSiteConfig(siteConfig);
    }

    const onNavChange = (type) => {
        if(type === "bin") {
            setBinShowFlag(true);
            setClusterShowFlag(false);
            setControllerShowFlag(false);
        } else if(type === 'cluster') {
            setBinShowFlag(false);
            setClusterShowFlag(true);
            setControllerShowFlag(false);
        } else if(type === 'controller') {
            setBinShowFlag(false);
            setClusterShowFlag(false);
            setControllerShowFlag(true);
        }
    }

    if (noLedControllers) {
        return <Alert
            type="informational"
            size="small">
            <FormattedMessage id="bintester.noLedControllersMessage"
                              defaultMessage="No LED controllers are configured for this station"/>
        </Alert>
    }

    if (!siteConfig.data) {
        if(siteConfig.status && siteConfig.status !== 200) {
            return <Alert
                type="informational"
                size="small">
                <FormattedMessage id="bintester.errorMessage"
                                  defaultMessage="An error occurred while fetching the site config for this station"/>
            </Alert>
        } else {
            return (<LoaderView/>)
        }
    } else {
        return (
            <div>
                <div>
                    <Navbar
                        siteId={siteId}
                        siteConfig={siteConfig}
                        onSiteIdChange={updateSiteId}
                        onSiteConfigChange={updateSiteConfig}
                        onNavChange={onNavChange}
                    />
                </div>

                {controllerShowFlag && <ControllerTesterPage
                    siteId={siteId}
                    siteConfig={siteConfig}
                />}

                {binShowFlag && (<BinTesterPage
                    siteId={siteId}
                    siteConfig={siteConfig}
                />)}

                {clusterShowFlag && <AisleTester
                    siteId={siteId}
                    siteConfig={siteConfig}
                />}
            </div>
        );
    }
}

export default injectIntl(BinTester);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/index.js